import styled, { css } from 'styled-components';
import { darken, lighten, transparentize } from 'polished';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { Container as MessageContainer } from 'components/MessageBox/styles';
import {
  CheckBoxWrapper,
  Container as SwitchContainer,
} from 'components/Switch/styles';

interface TdFlagProps {
  $isGe?: boolean;
  isIndisponivel?: boolean;
  isSelected?: boolean;
  size?: string;
}

interface CardProps {
  margin?: string;
  justify?: string;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-stretch;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
`;

export const Scroll = styled(PerfectScrollbar)`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 310px);
  padding: 0px 15px;
`;

export const Header = styled.div`
  flex-grow: auto;
  display: flex;
  flex-direction: row;
`;

export const Content = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
`;

export const LeftContent = styled.div`
  display: flex;
  flex: 1 1;
  padding: 10px 10px 0 0;
`;

export const RightContent = styled.div`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 10px 0 0 0;
  .graphSemanal {
    margin-top: 10px;
  }

  > div {
    display: flex;
  }
`;

export const Card = styled.div<CardProps>`
  background: ${props => props.theme.cardBackgroud};
  border: ${props =>
    props.theme.name === 'dark'
      ? 'none'
      : `2px solid ${props.theme.cardBorder}`};
  padding: 15px 0 0 0;
  border-radius: 5px;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;

  margin: ${props => props.margin};
  ${props =>
    props.theme.name === 'dark'
      ? css`
          box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
        `
      : css`
          box-shadow: 0 1px 15px 0 hsla(0, 0%, 48.2%, 0.05);
        `};

  header {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    padding: 0px 15px;
    height: 40px;

    p {
      opacity: 0.8;
    }

    nav {
      width: 100%;
      align-items: center;
    }
    > div {
      align-items: center;
    }
  }
  div {
    display: flex;
    justify-content: ${props => props.justify};
  }

  ${MessageContainer} {
    margin: 15px;
  }
`;

export const ChartContent = styled.div`
  padding: 0 15px 10px 15px;
  align-self: center;
  display: flex;
  width: 100%;
  height: 100%;
`;

export const PieChartContent = styled.div`
  padding: 0 8vw 5px 8vw;
  align-self: center;
  flex: 0;
  width: 100%;
  height: 100%;
`;

export const Table = styled.table`
  caret-color: transparent;
  width: 100%;
  border-collapse: collapse;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;

        &:nth-child(4) {
          text-align: center;
        }
        &:nth-child(5) {
          text-align: center;
        }
        &:last-of-type {
          text-align: right;
        }
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;
        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};
        ${SwitchContainer} {
          width: 100%;
          justify-content: center;
          ${CheckBoxWrapper} {
            position: absolute;
            align-self: center;
          }
        }
        &:last-of-type {
          div {
            &:first-of-type {
              justify-content: flex-end;
            }
          }
        }

        button {
          margin: 0;
        }
      }

      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
`;

// export const Align = styled.div`
//   justify-content: ${({ align }) =>
//     align === 'right' ? 'flex-end' : 'flex-start'};

//   display: flex;
//   color: ${props => props.theme.fontColor};
//   font-size: 1.0625rem;
//   font-weight: 400 !important;
// `;

// export const AlertFila = styled.div`
//   display: flex;
//   align-items: center;

//   svg {
//     margin-left: 10px;
//     font-size: 28px;
//     fill: ${props => props.theme.error};
//     z-index: 2;
//   }
//   position: relative;
//   ${props =>
//     props.showAnimation &&
//     css`
//       &::before {
//         content: '';
//         position: absolute;
//         height: 20px;
//         width: 20px;
//         top: 0.263rem;
//         left: calc(100% - 1.5rem);
//         border: 1px solid red;

//         border-radius: 50%;

//         fill-opacity: 0;
//         transform-origin: 50% 50%;
//         animation-duration: 1.7s;
//         animation-name: ${pulse};
//         animation-iteration-count: infinite;
//       }
//     `}
// `;

export const TdFlag = styled.td<TdFlagProps>`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isGe && !props.isIndisponivel
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : !props.$isGe && props.isIndisponivel
        ? css`
            background: ${props.theme.button.danger.out};
          `
        : props.$isGe && props.isIndisponivel
        ? css`
            background-image: linear-gradient(
              ${props.theme.button.danger.out},
              ${props.theme.button.warn.in}
            );
          `
        : css`
            pointer-events: none;
          `}
  }
`;
